export default class FooterContent {
    name = 'footer'
    footerRows = [
        `${this.name}.footer-row-1`,
        `${this.name}.footer-row-2`
    ];
}